module.exports = __webpack_public_path__ + "img/60.ae36a2e2.jpg";